export default [
    {
        name: 'email',
        title: 'Email',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '25%'
    },
    {
        name: 'status',
        title: 'Statuts',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '20%'
    },
    {
        name: 'createdAt',
        title: 'Envoyé',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    },
    {
        name: 'deliveredAt',
        title: 'Livré',
        titleClass: 'text-center',
        dataClass: 'text-center align-middle',
        width: '10%'
    }
];
